import Echo from "laravel-echo"
import Pusher from "pusher-js"

window.Pusher = Pusher

export default new Echo({
  broadcaster: "reverb",
  key: "k9x3m7vp2wq8nf5j",
  wsHost: "127.0.0.1",
  wsPort: 6001,
  forceTLS: false,
  enabledTransports: ["ws", "wss"],
  disableStats: true,
  authEndpoint: "http://127.0.0.1:9090/api/broadcasting/auth",
  auth: {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"), // if using Sanctum/JWT
      Accept: "application/json",
    },
  },
})
